// „Продадено без наличност" (`GET /inventory/stock/negative`): продуктите на минус
// в склада, от кои дни е минусът и колко от него би покрила доставка с избраната
// дата. Правилото (минусът от минали дни се отписва, от същия ден — покрива се)
// е САМО в BE (`stock_balance_rules.py`) — тук идва готовият резултат за датата.
// Договорът е в BE docs/inventory.md §Минусът от продажби и следващият приход.
import { api } from "./client";

export interface NegativeStockDay {
  date: string; // YYYY-MM-DD — денят в часовата зона на заведението
  quantity: number;
}

export interface NegativeStock {
  productId: number;
  negative: number; // колко е под нулата (положително число)
  days: NegativeStockDay[]; // стари → нови
  coverableQuantity: number; // доставка с датата би покрила толкова от минуса
  writtenOffQuantity: number; // ... а толкова се отписват (доставката влиза цяла)
}

export type NegativeStockParams = {
  warehouseId: number;
  date: string; // YYYY-MM-DD — датата на доставката
  productIds: number[];
  excludeMovementId?: number | null; // редакция — без самата доставка
};

// Масивът излиза като `?productIds=1&productIds=2` — BE-то очаква точно това
export async function getNegativeStock({
  excludeMovementId,
  ...params
}: NegativeStockParams): Promise<NegativeStock[]> {
  const res = await api.get<NegativeStock[]>("/inventory/stock/negative", {
    params: excludeMovementId != null ? { ...params, excludeMovementId } : params,
    paramsSerializer: { indexes: null },
  });
  return res.data;
}
